import { createFileRoute } from "@tanstack/react-router";
import { EnvironmentsPage } from "@/features/environments/EnvironmentsPage";
import { environmentsQuery } from "@/lib/api/queries";
import { projectSearch } from "@/lib/search";

export const Route = createFileRoute("/w/$workspace/p/$project/environments")({
  validateSearch: projectSearch,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(environmentsQuery(params.workspace, params.project)),
  component: () => {
    const { workspace, project } = Route.useParams();
    return <EnvironmentsPage workspace={workspace} project={project} />;
  },
});
